import { useTranslation } from "react-i18next"
import { Role, type Title } from "../../../../../types"
import type { Pkm } from "../../../../../types/enum/Pokemon"
import PokemonPortrait from "../pokemon-portrait"
import { BilibiliBadge } from "./bilibili-badge"
import { RoleBadge } from "./role-badge"

export function InlineAvatar(props: {
  avatar: string
  name: string
  title?: Title | ""
  role?: Role
  bilibiliMid?: string
  bilibiliName?: string
  bilibiliRoomId?: number
}) {
  const { t } = useTranslation()
  return (
    <div
      className="inline-avatar"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        gap: "0.25em"
      }}
    >
      <PokemonPortrait
        avatar={props.avatar}
        className="inline-avatar-img"
      />
      {props.title && (
        <span className="player-title">{t(`title.${props.title}`)}</span>
      )}
      <span className="player-name">
        {props.role === Role.BOT ? t(`pkm.${props.name as Pkm}`) : props.name}
      </span>
      {props.role && <RoleBadge role={props.role} />}
      <BilibiliBadge
        mid={props.bilibiliMid}
        name={props.bilibiliName}
        roomId={props.bilibiliRoomId}
      />
    </div>
  )
}
